var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2889_17527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FDFDFD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6611 39C28.362 39 28.1113 38.8988 27.909 38.6965C27.7067 38.4942 27.6056 38.2435 27.6056 37.9444C27.6056 37.8213 27.6319 37.6938 27.6847 37.5618C27.7375 37.4299 27.8167 37.3111 27.9222 37.2056L32.8042 32.3236L32.0389 31.5583L27.1833 36.4403C27.0778 36.5458 26.9634 36.625 26.8403 36.6778C26.7171 36.7306 26.5852 36.7569 26.4444 36.7569C26.1454 36.7569 25.8947 36.6558 25.6924 36.4535C25.49 36.2512 25.3889 36.0005 25.3889 35.7014C25.3889 35.5255 25.4153 35.3803 25.4681 35.266C25.5208 35.1516 25.5912 35.0505 25.6792 34.9625L30.5611 30.0806L29.8222 29.3417L24.9403 34.1972C24.8347 34.3028 24.7204 34.3819 24.5972 34.4347C24.4741 34.4875 24.3333 34.5139 24.175 34.5139C23.8935 34.5139 23.6472 34.4083 23.4361 34.1972C23.225 33.9861 23.1194 33.7398 23.1194 33.4583C23.1194 33.3176 23.1458 33.1856 23.1986 33.0625C23.2514 32.9394 23.3306 32.825 23.4361 32.7194L28.3181 27.8375L27.5528 27.0986L22.6972 31.9806C22.6093 32.0685 22.5037 32.1389 22.3806 32.1917C22.2574 32.2444 22.1079 32.2708 21.9319 32.2708C21.6329 32.2708 21.3822 32.1697 21.1799 31.9674C20.9775 31.765 20.8764 31.5144 20.8764 31.2153C20.8764 31.0745 20.9028 30.9426 20.9556 30.8194C21.0083 30.6963 21.0875 30.5819 21.1931 30.4764L27.0778 24.5917L31.0361 28.5764C31.2296 28.7699 31.4583 28.9238 31.7222 29.0382C31.9861 29.1525 32.25 29.2097 32.5139 29.2097C33.0769 29.2097 33.5694 29.0118 33.9917 28.616C34.4139 28.2201 34.625 27.7144 34.625 27.0986C34.625 26.8523 34.581 26.5972 34.4931 26.3333C34.4051 26.0694 34.2468 25.8231 34.0181 25.5944L29.2944 20.8708C29.5935 20.5894 29.9278 20.3738 30.2972 20.2243C30.6667 20.0748 31.0361 20 31.4056 20C31.863 20 32.2852 20.0748 32.6722 20.2243C33.0593 20.3738 33.4111 20.6069 33.7278 20.9236L38.1875 25.4097C38.5042 25.7264 38.7373 26.0782 38.8868 26.4653C39.0363 26.8523 39.1111 27.3009 39.1111 27.8111C39.1111 28.163 39.0319 28.5192 38.8736 28.8799C38.7153 29.2405 38.4866 29.5704 38.1875 29.8694L29.4 38.6833C29.2593 38.8241 29.1361 38.912 29.0306 38.9472C28.925 38.9824 28.8019 39 28.6611 39ZM19.6097 30.5556L18.9236 29.8694C18.6245 29.588 18.3958 29.2537 18.2375 28.8667C18.0792 28.4796 18 28.075 18 27.6528C18 27.1954 18.088 26.7731 18.2639 26.3861C18.4398 25.9991 18.6597 25.6736 18.9236 25.4097L23.3833 20.9236C23.6648 20.6421 23.9991 20.4178 24.3861 20.2507C24.7731 20.0836 25.1514 20 25.5208 20C25.9958 20 26.4181 20.066 26.7875 20.1979C27.1569 20.3299 27.5176 20.5718 27.8694 20.9236L33.2792 26.3333C33.3847 26.4389 33.4639 26.5532 33.5167 26.6764C33.5694 26.7995 33.5958 26.9315 33.5958 27.0722C33.5958 27.3537 33.4903 27.6 33.2792 27.8111C33.0681 28.0222 32.8218 28.1278 32.5403 28.1278C32.3819 28.1278 32.25 28.1058 32.1444 28.0618C32.0389 28.0178 31.9245 27.9343 31.8014 27.8111L27.0514 23.1139L19.6097 30.5556Z",
    fill: "#D1D5D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2889_17527",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2889_17527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2889_17527",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Off);
export default __webpack_public_path__ + "static/media/step3-off.7255970a99bb95f06dd5c50b5aab3527.svg";
export { ForwardRef as ReactComponent };